import React from 'react';
import styled from 'styled-components';

interface GroupMemberViewerShellProps {
  children: React.ReactNode;
  isMobile: boolean;
}

const GroupMemberViewerShell: React.FC<GroupMemberViewerShellProps> = ({ children, isMobile }) => (
  <Shell $isMobile={isMobile}>{children}</Shell>
);

export default GroupMemberViewerShell;

const Shell = styled.section<{ $isMobile: boolean }>`
  position: relative;
  height: 100%;
  min-height: 0;

  flex: 1;
  flex-direction: column;
  border-left: ${({ $isMobile, theme }) =>
    $isMobile ? 'none' : `1px solid ${theme.colors.color_Gray_05}`};
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  padding-bottom: 40px;
`;
